export default __webpack_public_path__ + "static/media/mMT4.090fce76.png";